import { render, staticRenderFns } from "./RouteDetailsSidebar.vue?vue&type=template&id=024d1a49&scoped=true"
import script from "./RouteDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./RouteDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./RouteDetailsSidebar.vue?vue&type=style&index=0&id=024d1a49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d1a49",
  null
  
)

export default component.exports